/* Dependencies
 ----------------------------------------------------------*/
import {Application} from "wrapper6";

/* Vendor
 ----------------------------------------------------------*/


/* Setup
 ----------------------------------------------------------*/
var app = window.app = new Application(window.options || {});

/* Services
 ----------------------------------------------------------*/


/* Register services
 ----------------------------------------------------------*/

/* Modules
 ----------------------------------------------------------*/
import Navigation from "../modules/_navigation.js";
import ObjectFit from "../modules/_object-fit.js";
import Print from "../modules/_print.js";
import Sliders from "../modules/_sliders.js";
import SmoothScroll from "../modules/_smooth_scroll.js";
import Sticky from "../modules/_sticky.js";
import Search from "../modules/_search.js";
import CustomizeModal from "../modules/_customize-modal.js";
import Catch from "../modules/_catch.js";
import Finance from "../modules/_finance.js";
import ProductPage from "../modules/_product-page";
import CartAutoUpdate from "../modules/_cart-auto-update.js";
import ShippingSelect from "../modules/_shipping-select.js";
import PickupPointPicker from "../modules/_pickup-point-picker";
import ContactTracking from "../modules/_contact-tracking.js";
import ProductVariationImageHandler from "../modules/_product-variation-image-handler.js";
import GiftWrapper from '../modules/_giftwapper'
import SwiperSlides from '../modules/_swiper-slides'

/* Register modules
 ----------------------------------------------------------*/
app.use(ProductPage);
app.use(Navigation);
app.use(ObjectFit);
app.use(Print);
app.use(Sliders);
app.use(SmoothScroll);
app.use(Sticky);
app.use(Search);
app.use(CustomizeModal);
app.use(Catch);
app.use(Finance);
app.use(CartAutoUpdate);
app.use(ShippingSelect);
app.use(PickupPointPicker);
app.use(ContactTracking);
app.use(ProductVariationImageHandler);
app.use(GiftWrapper)
app.use(SwiperSlides)


// WEBPACK FOOTER //
// ./resources/js/public/main.js